import { useState } from "react";
import { feedList } from "@/mocks/home";
import SectionHeading from "./SectionHeading";

const tabs = [
  { key: "latest", label: "最新发布" },
  { key: "hot", label: "热榜飙升" },
] as const;

export default function Feed() {
  const [tab, setTab] = useState<"latest" | "hot">("latest");
  const data = tab === "hot" ? feedList.filter((it) => it.hot) : feedList;

  return (
    <section id="feed" className="bg-background-100/70">
      <div className="mx-auto w-full max-w-6xl px-4 py-12 md:px-6 md:py-16">
        <SectionHeading
          eyebrow="LIVE 动态"
          title="吃瓜地址最新发布页 · 实时讨论"
          desc="按时间与热度呈现社区正在跟进的话题。每条都由标题与短摘要组成，快速扫一眼就能决定要不要进场深聊。"
          action={
            <div className="flex items-center rounded-full border border-background-200 bg-background-50 p-1">
              {tabs.map((t) => (
                <button
                  key={t.key}
                  type="button"
                  onClick={() => setTab(t.key)}
                  className={`whitespace-nowrap rounded-full px-4 py-2 text-sm font-medium transition-colors ${
                    tab === t.key
                      ? "bg-primary-500 text-background-50"
                      : "text-foreground-600 hover:text-foreground-900"
                  }`}
                >
                  {t.label}
                </button>
              ))}
            </div>
          }
        />

        <div className="mt-8 flex flex-col gap-4">
          {data.map((it, idx) => (
            <article
              key={it.title}
              className="group flex items-start gap-4 rounded-xl border border-background-200/80 bg-background-50 p-4 transition-colors hover:border-primary-300/70 md:gap-6 md:p-5"
            >
              {/* 序号/热力 */}
              <div className="flex shrink-0 flex-col items-center pt-0.5">
                {tab === "hot" ? (
                  <span
                    className={`font-heading text-lg font-bold md:text-xl ${
                      idx < 3 ? "text-primary-600" : "text-secondary-500"
                    }`}
                  >
                    {idx + 1}
                  </span>
                ) : (
                  <span className="flex h-7 w-7 items-center justify-center rounded-md bg-secondary-100 text-xs font-semibold text-secondary-700">
                    {String(idx + 1).padStart(2, "0")}
                  </span>
                )}
                {idx < 3 && it.hot && (
                  <span className="mt-1.5 hidden items-center gap-0.5 text-[11px] text-accent-600 md:inline-flex">
                    <i className="ri-fire-line"></i>热
                  </span>
                )}
              </div>

              {/* 内容 */}
              <div className="min-w-0 flex-1">
                <div className="flex flex-wrap items-center gap-2">
                  <span
                    className={`inline-flex items-center rounded-full px-2 py-0.5 text-[11px] font-semibold ${
                      it.meta.hot
                        ? "bg-accent-100 text-accent-800"
                        : "bg-secondary-100 text-secondary-700"
                    }`}
                  >
                    {it.tag}
                  </span>
                  <span className="text-xs text-foreground-400">{it.meta.time}</span>
                </div>
                <h3 className="mt-2 cursor-pointer text-[15px] font-semibold leading-snug text-foreground-950 transition-colors group-hover:text-primary-700 md:text-base">
                  {it.title}
                </h3>
                <p className="mt-1.5 line-clamp-2 text-sm leading-relaxed text-foreground-600">{it.summary}</p>
              </div>

              {/* 指标 + 进场 */}
              <div className="hidden shrink-0 flex-col items-end justify-between gap-2 self-stretch md:flex">
                <div className="flex items-center gap-4 text-xs text-foreground-500">
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-eye-line"></i>
                    {it.meta.view}
                  </span>
                  <span className="inline-flex items-center gap-1">
                    <i className="ri-chat-3-line"></i>
                    {it.meta.reply}
                  </span>
                </div>
                <button
                  type="button"
                  className="inline-flex items-center gap-1 whitespace-nowrap rounded-md border border-background-200 px-3 py-1.5 text-xs font-medium text-foreground-700 transition-colors hover:border-primary-400 hover:bg-primary-50 hover:text-primary-700"
                >
                  进帖聊聊
                  <i className="ri-arrow-right-line"></i>
                </button>
              </div>
            </article>
          ))}
        </div>

        <div className="mt-6 text-center">
          <button
            type="button"
            className="inline-flex items-center gap-2 whitespace-nowrap rounded-md border border-secondary-300 bg-background-50 px-5 py-2.5 text-sm font-semibold text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
          >
            加载更多讨论
            <i className="ri-refresh-line"></i>
          </button>
        </div>
      </div>
    </section>
  );
}